import { useState } from "react"
import { API_ROUTES, userIsLogged, useTitle } from "../../helpers"

export default function HouseSauter({ activeTab }) {

    useTitle('LMOAPPS - House Sauter')

    document.body.className = 'body-house'


    return (
        <>
            <div className="overlay overlay-house"></div>
            <nav className={"navbar navbar-expand navbar-light house-nav"}>
                <div className="container-fluid">
                    <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                        <div className="navbar-nav m-auto">
                            <a href="./pilotage" className={"nav-link" + ' ' + (activeTab === 'pilotage' ? 'active' : null)}><i className="fa fa-thermometer-half"></i>
                                <span>Chauffage</span>
                            </a>
                            <a href="./prog" className={"nav-link" + ' ' + (activeTab === 'prog' ? 'active' : null)}><i
                                className="fa fa-clock-o"></i>
                                <span>Prog</span>
                            </a>
                            <a href="./elec" className={"nav-link" + ' ' + (activeTab === 'elec' ? 'active' : null)}><i
                                className="fa fa-bolt"></i>
                                <span>Conso Elec</span>
                            </a>
                        </div>
                    </div>
                </div>
            </nav >
        </>)

}
